import GlobalFonts from './theme/fonts'
import GlobalStyle from './theme/globalStyle'
import { ThemeProvider } from 'styled-components'
import theme from './theme/theme'
import Main from './components/Index/Main'

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalFonts />
      <GlobalStyle />
      <Main />
    </ThemeProvider>
  )
}

export default App
